import React from 'react';

import { Wrapper } from './styled/TrainerTranscriptAnonymizationStyled';

const hidden = '<hidden>';

function Anonymization(props: { text: string; anonymized: boolean }) {
    const { text, anonymized } = props;

    return anonymized ? <Wrapper>{hidden}</Wrapper> : <>{text}</>;
}

export default Anonymization;
